import { defineStore } from 'pinia';

export const useFireworkStore = defineStore({
	id: 'firework',

	state: () => ({
		my_fireworks: [],
		is_reloading: false,
	}),

	actions: {
		setMyFireworks(fireworks) {
			// only add unique fireworks based on firework_IDs and updated_on values
			const existing_fireworks_map = new Map(this.my_fireworks.map((firework) => [firework.firework_ID, firework]));

			for (let i = 0; i < fireworks.length; i++) {
				const firework = fireworks[i];
				const existing_firework = existing_fireworks_map.get(firework.firework_ID);

				if (existing_firework == undefined) {
					existing_fireworks_map.set(firework.firework_ID, firework);
				} else {
					const existing_updated_on = new Date(existing_firework.updated_on);
					const new_updated_on = new Date(firework.updated_on);

					if (new_updated_on > existing_updated_on) {
						existing_fireworks_map.set(firework.firework_ID, firework);
					}
				}
			}

			this.my_fireworks = Array.from(existing_fireworks_map.values());
		},
		resetMyFireworks() {
			this.my_fireworks = [];
		},
		setIsReloading(is_reloading) {
			this.is_reloading = is_reloading;
		},
		updateFirework(firework) {
			this.my_fireworks = this.my_fireworks.map((existing_firework) => (existing_firework.firework_ID == firework.firework_ID ? firework : existing_firework));
		},
		getFireworkInfo(firework_id) {
			return this.my_fireworks.find((firework) => firework.firework_ID == firework_id);
		},
	},
});
